import gql from 'graphql-tag';
import { FetchPolicy } from 'apollo-client';
import { client } from '../..';
import { showNotification } from '../../App';

export interface UserAIActivitiesQueryParams {
    offset: number;
    first: number;
    searchCriterias: string;
    filter: string | null;
}

export interface AddUserAIActivityParams {
    accessType: string;
    accessSubType: string;
    question: string | null;
}

export enum UserAIAccessType {
    CRMContact = 0,
    CRMOutlook,
    CRMTextEditor,
    FirmDashboard,
    FeeEarnerDashboard
}

export function getAIAccessType(type: UserAIAccessType) {
    switch (type) {
        case 0: return 'CRMContact';
        case 1: return 'CRMOutlook';
        case 2: return 'CRMTextEditor';
        case 3: return 'FirmDashboard';
        default: break;
    }

    return 'FeeEarnerDashboard';
}

export type UserAIActivitiesData = {
    administrator: Administrator;
};

export type Administrator = {
    userAIActivities: UserAIActivities;
};

export type UserAIActivities = {
    userAIActivity: UserAIActivity[];
    recordCount:     number;
};

export type UserAIActivity = {
    guidId:             string;
    name:               number;
    accessType:         string;
    accessSubType:      string;
    accessTime:         Date;
    questing:           string;
    accessSource:       string;
};

export function retrieveUserAIActivityData(
    query: UserAIActivitiesQueryParams, 
    refreshData: boolean,
    onSuccess: (data: UserAIActivitiesData) => void,
    // tslint:disable-next-line:no-any
    onError: (reason: any) => void)
    : void {
        var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';
        
        client.query<UserAIActivitiesData, UserAIActivitiesQueryParams>({
            query: UserAIActivityQuery,
            variables: {
                offset: query.offset,
                first: query.first,
                searchCriterias: query.searchCriterias,
                filter: query.filter
            },
            fetchPolicy: fetchPolicy
        })
    // tslint:disable-next-line:no-any
    .then((results) => {
            onSuccess(results.data);
    })
    // tslint:disable-next-line:no-any
    .catch((reason: any ) => { onError(reason); }
    );
}

export function addUserAIActivity(params: AddUserAIActivityParams) {
    client.mutate({
        mutation: AddUserAIActivityMutation,
        variables: params
    // tslint:disable-next-line: no-any
    }).then((results) => {
        // do nothing
    // tslint:disable-next-line: no-any
    }).catch((reason: any) => {
        showNotification('Failed to save AI Access', reason, 'error');
    });
}

const UserAIActivityQuery = gql`
query UserAIActivityDrilldownList($offset: Int, $first: Int, $filter: String, $searchCriterias: String) {
    administrator {
        userAIActivities(offset: $offset, first: $first, filter: $filter, searchCriterias: $searchCriterias) {
            recordCount
            rowCountWithoutFilters
            userAIActivity {
                id
                username
                role
                accessType
                accessSubType
                accessTime
                question
                accessSource
            }
        }
    }
}
`;

export const AddUserAIActivityMutation = gql`
mutation AddUserAIActivity($accessType: AIAccessType, $accessSubType: String, $question: String){
    addUserAIActivity(accessType: $accessType, accessSubType: $accessSubType, question: $question)
}
`;